var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9766 1.66602C15.3734 1.66602 14.7703 1.8957 14.3099 2.35612L13.3333 3.33268L16.6667 6.66602L17.6432 5.68945C18.5632 4.76945 18.5632 3.27695 17.6432 2.35612C17.1828 1.8957 16.5797 1.66602 15.9766 1.66602ZM12.0833 4.58268L2.5 14.166V17.4993H5.83333L15.4167 7.91602L12.0833 4.58268Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/edit-filled.0d41267457858402635c84d78eb970a0.svg";
export { ForwardRef as ReactComponent };